import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const ProductAlertInfo = styled.div`
  display: grid;
  grid-auto-flow: column;
  column-gap: ${layout.measurements.spacing050};
  align-items: center;
`;

export const ProductInfoName = styled.div`
  flex-grow: 1;
  margin: 0 1rem;

  h2 {
    font-size: 1rem;
    font-weight: normal;
    margin-bottom: 0.25rem;
  }
`;

const IMAGE_MAX_WIDTH = 64;

export const ProductInfoImage = styled.img`
  max-width: ${IMAGE_MAX_WIDTH}px;
`;
